export default {
  namespaced: true,
  state: () => ({
    dadosComissoes: [],
    // Armazena todos os registros (todas as páginas) para cálculo de totais
    allDadosComissoes: [],
    loading: false,
    loadingTotals: false,
    filters: {
      page: 1,
      perPage: 10,
      cod_repres: null,
      dt_emis: null,
    },
    meta: {
      page: 1,
      perPage: 10,
      pages: 1,
      total: 0,
    },
  }),
  mutations: {
    SET_DADOS_COMISSOES(state, data) {
      state.dadosComissoes = data;
    },
    SET_ALL_DADOS_COMISSOES(state, data) {
      state.allDadosComissoes = data;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_LOADING_TOTALS(state, loading) {
      state.loadingTotals = loading;
    },
    SET_FILTERS(state, filters) {
      state.filters = { ...state.filters, ...filters };
    },
    SET_META(state, meta) {
      state.meta = meta;
    },
    CLEAR_FILTERS(state) {
      state.filters = {
        page: 1,
        perPage: 10,
        cod_repres: null,
        dt_emis: null,
      };
    },
  },
  getters: {
    getDadosComissoes: (state) => state.dadosComissoes,
    getAllDadosComissoes: (state) => state.allDadosComissoes,
    getLoading: (state) => state.loading,
    getLoadingTotals: (state) => state.loadingTotals,
    getFilters: (state) => state.filters,
    getMeta: (state) => state.meta,
  },
  actions: {
    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters);
    },
    clearFilters({ commit }) {
      commit('CLEAR_FILTERS');
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading);
    },
    setAllDadosComissoes({ commit }, data) {
      commit('SET_ALL_DADOS_COMISSOES', data);
    },
    clearAllDadosComissoes({ commit }) {
      commit('SET_ALL_DADOS_COMISSOES', []);
    },
    setLoadingTotals({ commit }, loading) {
      commit('SET_LOADING_TOTALS', loading);
    },
  },
};
